import type { FaireProductEntity } from "../../entity_types/product";

export const p_csq9nhdf5a: FaireProductEntity = {
  token: "p_csq9nhdf5a",
  type: "product",
  name: "Sweet Vanilla - 5oz Beef Tallow & Goat Milk Soap",
  brandName: "Milk Lather Soap Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6342b1d49d7274e76a63a668053bb3f138efaddd0be04a848e1693d6f558f13b.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ee065c62718d565d0309a20f3bdefdfcfb86a4738c0648b0097524783aa37bd5.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
